import { BaseService } from "@/core/services/BaseService";

class AuditService extends BaseService<any > {
  endpoint = "/audit"

}

export default new AuditService();